import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { BaseSelectionControl } from '../base-selection-control/base-selection-control.component';
import { KeyValuePipe, NgClass } from "@angular/common";
import { NgbDropdown, NgbDropdownItem, NgbDropdownMenu, NgbDropdownToggle } from "@ng-bootstrap/ng-bootstrap";
import { QuestionUtils } from "../../../utils/question.utils";


/**
 * Control to render a dropdown select
 *
 * @author Dan Bennett (dbennett)
 */
@Component({
    standalone: true,
    selector: 'dropdown-control',
    templateUrl: './dropdown-control.component.html',
    styleUrls: [
        './dropdown-control.component.sass',
        '../../base-form/base-form.component.sass',
        '../base-input-control/base-input-control.component.sass'
    ],
    imports: [
        KeyValuePipe,
        NgClass,
        NgbDropdown,
        NgbDropdownToggle,
        NgbDropdownMenu,
        NgbDropdownItem
    ],
    encapsulation: ViewEncapsulation.None
})
export class DropdownControl extends BaseSelectionControl implements OnInit {

    constructor() {
        super();

        this.inputType = 'dropdown';
        this.inputClass = '';
    }

    override ngOnInit() {
        super.ngOnInit();

        if (this.editingResponse) {
            this.setPreviousResponse()
        }
    }

    selectOption(value: string) {
        this.control.setValue(value);
        this.control.updateValueAndValidity();
        super.setModelValue(this.control.value)
    }

    getOption(key: string | undefined): string | undefined {
        let value = undefined;
        if (key) {
            value = QuestionUtils.getOptionDisplayValue(this.baseForm.type, this.question, this.messages, key)
            value = `${this.baseForm.type}.option.${this.questionId}.${key.toLowerCase().replace(/[,:| ]/g, '')}`
        }
        return value;
    }

}
